<!-- O campo é o topo da paleta: sem `mat-form-field`, sem rótulo flutuante,
sem moldura — é o desenho da referência e é o que a norma pede para um
controle que não é formulário. -->
<div class="mg-paleta__campo">
  <mat-icon svgIcon="search" aria-hidden="true" class="mg-paleta__lupa"></mat-icon>

  <input
    type="text"
    class="mg-paleta__entrada"
    [formControl]="campo"
    placeholder="Buscar cliente, fornecedor, colaborador ou tela…"
    aria-label="Buscar no sistema"
    autocomplete="off"
    role="combobox"
    aria-controls="mg-paleta-resultados"
    [attr.aria-expanded]="gruposVisiveis.length > 0"
    [attr.aria-activedescendant]="itemAtivoId"
    (keydown)="aoTeclar($event)" />

  <button type="button" class="mg-paleta__tecla" (click)="fechar()" aria-label="Fechar busca">Esc</button>
</div>

<div class="mg-paleta__corpo">
  <p class="mg-paleta__legenda">Estou procurando por…</p>

  <mat-chip-listbox class="mg-paleta__chips" aria-label="Tipo de resultado">
    @for (tipo of chips; track tipo) {
      <mat-chip-option
        [selected]="tipoSelecionado === tipo"
        (click)="alternarTipo(tipo)">
        <mat-icon matChipAvatar [svgIcon]="iconeDe(tipo)" aria-hidden="true"></mat-icon>
        {{ rotuloDe(tipo) }}
      </mat-chip-option>
    }
  </mat-chip-listbox>

  <div id="mg-paleta-resultados" class="mg-paleta__resultados" role="listbox" aria-label="Resultados">
    @for (grupo of gruposVisiveis; track grupo.tipo) {
      <div class="mg-paleta__grupo" role="group" [attr.aria-label]="grupo.rotulo">
        <p class="mg-paleta__grupo-titulo">{{ grupo.rotulo }}</p>

        @for (item of grupo.itens; track item.id) {
          <button
            type="button"
            class="mg-paleta__linha"
            role="option"
            [mgItemDeBusca]="item"
            [idDoItem]="'mg-paleta-' + grupo.tipo + '-' + item.id"
            [attr.aria-selected]="refDoItem.ativo"
            #refDoItem="mgItemDeBusca"
            (click)="escolher(item)">
            <span class="mg-paleta__caixa">
              <mat-icon [svgIcon]="grupo.icone" aria-hidden="true"></mat-icon>
            </span>
            <span class="mg-paleta__rotulos">
              <span class="mg-paleta__titulo">{{ item.titulo }}</span>
              @if (item.subtitulo) {
                <span class="mg-paleta__subtitulo">{{ item.subtitulo }}</span>
              }
            </span>
          </button>
        }
      </div>
    }

    @if (buscaConcluida && !buscando && campo.value.trim().length >= minimo && gruposVisiveis.length === 0) {
      <p class="mg-paleta__vazio">Nada encontrado para "{{ campo.value }}".</p>
    }
  </div>
</div>

<div class="mg-paleta__rodape">
  <span><span class="mg-paleta__tecla">↑</span><span class="mg-paleta__tecla">↓</span> Navegar</span>
  <span><span class="mg-paleta__tecla">↵</span> Selecionar</span>
  <span class="mg-paleta__rodape-fim"><span class="mg-paleta__tecla">Esc</span> Fechar</span>
</div>
